import React, {useState, useEffect} from "react";
import CustomToolbar from "../../CustomToolbar";
import {Container, Dialog, Slide, TextField, CircularProgress, Button} from "@material-ui/core";
import {Close, Check, CloudDownloadOutlined} from "@material-ui/icons";
import {MuiThemeProvider} from "@material-ui/core/styles";
import {Autocomplete} from "@material-ui/lab";
import MUIDataTable from "mui-datatables";
import {datatableThemeInTabsPage} from "assets/css/datatable-theme.js";
import FilterComponent from "./Components/FilterComponent.js";
import SubTables from "./Components/SubTables.js";
import ImportXlsx from "./Components/ImportXlsx.js";
import axios from "axios";
import {getCookie} from "components/auth/Helpers";
import SnDialog from "./Components/SnDialog.js";

import AddFormDialog from "components/CustomComponents/AddFormDialog.js";
import Moment from "react-moment";
import moment from "moment";
import TabsOnTop from "./Components/TabsOnTop.js";

import EditStatus from "./Components/EditStatus";
import EditLocation from "./Components/EditLocation";
import {IconButton} from "material-ui";

import UploadExcel from "./Components/UploadExcel";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Cabinet = () => {
  const token = getCookie("token");
  const [isLoading, setIsLoading] = useState(true);
  const [openAddForm, setOpenAddForm] = useState(false); //for modal
  const [cabinetId, setCabinetId] = useState(); //modal title
  const [formTitle, setFormTitle] = useState("Add"); //modal title
  const [filterDialog, setFilterDialog] = useState(false);
  const [items, setItems] = useState([]); //table items
  const [openDialog2, setOpenDialog2] = useState(false); //for modal2
  const [cabinetsToExport, setCabinetsToExport] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [storesList, setStoresList] = useState([]);
  const [warehousesList, setWarehousesList] = useState([]);
  const [neighbourhoodsList, setNeighbourhoodsList] = useState([]);
  const [clientsList, setClientsList] = useState([]);
  const [fridgesTypesList, setFridgesTypesList] = useState([]);
  const [modal_Title, setmodal_Title] = useState("Add"); //modal title
  const [itemsFiltered, setItemsFiltered] = useState(); //tabs items
  const [tabIndex, setTabIndex] = useState(0);
  const [pagingInfo, setPagingInfo] = useState({page: 0, limit: 10, skip: 0, count: 0}); //Pagination Info
  const [searchEntry, setSearchEntry] = useState([]); //searchEntry
  const [importXlsx, setImportXlsx] = useState(false); //Import Excel
  const [cabinetsList, setCabinetsList] = useState([]);
  const [openSnDialog, setOpenSnDialog] = useState(false);
  const [snId, setSnId] = useState();
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [openEditStatus, setOpenEditStatus] = useState(false);
  const [openEditLocation, setOpenEditLocation] = useState(false);
  const [cabinet, setCabinet] = useState([]);
  const [city, setCityValue] = useState("");
  const [neighbourhood, setNeighbourhoodValue] = useState("");
  const [mobile, setMobileValue] = useState("");
  const [countLive, setCountLive] = useState({});
  const [filterFormValues, setFilterFormValues] = useState({
    client: "",
    fridgesType: "",
    status: "",
    prevStatus: "",
    fromDate: "",
    toDate: "",

    location: "",
    store: "",
    warehouse: "",

    condition: "",

    booking: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/cities`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/neighbourhoods`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/stores`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/warehouses`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          // axios.get(`${process.env.REACT_APP_BASE_URL}/preventiveActions`,{headers: {Authorization: `Bearer ${token}`}}),
          // axios.get(`${process.env.REACT_APP_BASE_URL}/cabinets`, {
          //   headers: {Authorization: `Bearer ${token}`},
          // }),
        ])
        .then((response) => {
          setCitiesList(response[0].data);
          setNeighbourhoodsList(response[1].data);
          setClientsList(response[2].data);
          setStoresList(response[3].data);
          setWarehousesList(response[4].data);
          setFridgesTypesList(response[5].data);
          // setCabinetsList(response[6].data.data);
        });
    };
    fetchData();
  }, [openAddForm]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await axios(`${process.env.REACT_APP_BASE_URL}/cabinets/export`, {
  //       responseType: "json",
  //       headers: {Authorization: `Bearer ${token}`},
  //     }).then((response) => {
  //       setCabinetsToExport(response.data);
  //     });
  //   };
  //   fetchData();
  // }, []);

  /**************** -OnClickItemDialog START- **************/
  const fetchData = async () => {
    setItemsFiltered();
    let filterArray = [];

    if (filterFormValues.condition) filterArray.push(`condition=${filterFormValues.condition.id}`);
    if (filterFormValues.is_new) filterArray.push(`is_new=${filterFormValues.is_new.id}`);
    if (filterFormValues.booking) filterArray.push(`booking=${filterFormValues.booking.id}`);
    if (filterFormValues.location) filterArray.push(`location=${filterFormValues.location.id}`);
    if (filterFormValues.store) filterArray.push(`location_id=${filterFormValues.store._id}`);
    if (filterFormValues.warehouse) filterArray.push(`location_id=${filterFormValues.warehouse._id}`);

    if (filterFormValues.client._id) filterArray.push(`clientId=${filterFormValues.client._id}`);
    if (filterFormValues.fridgesType._id)
      filterArray.push(`fridgeTypeId=${filterFormValues.fridgesType._id}`);
    if (filterFormValues.prevStatus) filterArray.push(`prevStatus=${filterFormValues.prevStatus}`);
    if (filterFormValues.status) filterArray.push(`status=${filterFormValues.status}`);
    if (filterFormValues.fromDate) filterArray.push(`fromDate=${filterFormValues.fromDate}`);
    if (filterFormValues.toDate) filterArray.push(`toDate=${filterFormValues.toDate}`);

    filterArray.push(`status=${tabIndex > 0 ? tabsTitle[tabIndex - 1] : ""}`);

    await axios(
      `${process.env.REACT_APP_BASE_URL}/cabinets?limit=${pagingInfo.limit}&skip=${
        pagingInfo.skip
      }&searchEntry=${searchEntry}&${filterArray.join("&")}`,
      {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      }
    )
      .then((response) => {
        setCountLive({total: response.data.count, data: response.data.tabs});

        setPagingInfo({...pagingInfo, count: response.data.count});
        setItems(response.data.data);
        return setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    fetchData();
  }, [
    openAddForm,
    openEditStatus,
    openEditLocation,
    pagingInfo.page,
    pagingInfo.limit,
    searchEntry,
    tabIndex,
  ]);

  const handleImportXlsx = () => {
    setImportXlsx(true);
  };

  const handleOpenSnDialog = (id) => {
    setOpenSnDialog(true);
    setSnId(id);
  };
  /**************** -OnClickItemDialog END- **************/
  const columns = [
    {
      name: "_id",
      options: {
        display: false,
      },
    },
    {
      name: "sn",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let typeValue = "-";
          if (fridgesTypesList.filter((e) => e._id === value)[0]) {
            typeValue = fridgesTypesList.filter((e) => e._id == value)[0].refrigerant_type;
          }
          return (
            <div>
              <a onClick={() => handleOpenSnDialog(tableMeta.rowData[0])}>{value}</a>
            </div>
          );
        },
      },
    },
    {
      name: "sn2",
    },
    {
      name: "type",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let typeValue = "-";
          if (fridgesTypesList.filter((e) => e._id === value)[0]) {
            typeValue = fridgesTypesList.filter((e) => e._id == value)[0].refrigerant_type;
          }
          return typeValue;
        },
      },
    },
    {
      name: "brand",
    },
    {
      name: "manufacturer",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let typeValue = "-";
          if (fridgesTypesList.filter((e) => e._id === tableMeta.rowData[3])[0]) {
            typeValue = fridgesTypesList.filter((e) => e._id == tableMeta.rowData[3])[0]?.name;
          }
          return typeValue;
        },
      },
    },
    {
      name: "client",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let companyValue = "-";
          let avatarValue = "";
          if (clientsList.filter((e) => e._id === value)[0]) {
            companyValue = clientsList.filter((e) => e._id == value)[0]?.name;
            let valueArray = companyValue.split(" ");
            avatarValue =
              valueArray.length > 1
                ? valueArray[0].charAt(0) + valueArray[1].charAt(0)
                : valueArray[0].substring(0, 2);
          }
          return (
            <div className="d-flex">
              <div className="avatar_circle">{avatarValue}</div>
              {companyValue}
            </div>
          );
        },
      },
    },
    {
      name: "days_to_prev",
      label: "Days To Prev",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let currentRowInFridgeType = fridgesTypesList.filter((e) => e._id === tableMeta.rowData[3])[0];
          let prevCountPerYear = currentRowInFridgeType ? currentRowInFridgeType.preventive_count_year : 1;
          let daysFromLastPrev = Math.round(
            (moment().unix() - moment(tableMeta.rowData[8]).unix()) / 12 / 30 / 24 / 24
          );
          return tableMeta.rowData[8] ? Math.round(365 / prevCountPerYear - daysFromLastPrev) : "NA";
        },
      },
    },
    {
      name: "last_prev_date",
      label: "Last Preventive Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <Moment format="DD MMM YYYY">{value}</Moment> : "NA";
        },
      },
    },
    {
      name: "prev_status",
      label: "Preventive Status",
    },
    {
      name: "finance",
      label: "Finance $",
    },
    {
      name: "location",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let locationValue;
          if (value === "store") {
            locationValue = storesList.find((e) => e._id === tableMeta.rowData[12]);
          } else if (value === "warehouse") {
            locationValue = warehousesList.find((e) => e._id === tableMeta.rowData[12]);
          }

          return `${locationValue ? locationValue.code : ""}  ${
            locationValue ? locationValue.name : ""
          } (${value})`;
        },
      },
    },
    {
      name: "location_id",
      label: "Address",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let cityValue = "-";
          let neighbourhoodValue = "-";
          let mobileValue = "-";
          if (tableMeta.rowData[11] === "store") {
            if (storesList.find((e) => e._id == value)) {
              let locationValue = storesList.find((e) => e._id == value).location;
              if (citiesList.find((e) => e._id == locationValue.city_id)) {
                cityValue = citiesList.find((e) => e._id == locationValue.city_id).name;
              }
              if (neighbourhoodsList.find((e) => e._id == locationValue.neighbourhood_id)) {
                neighbourhoodValue = neighbourhoodsList.find((e) => e._id == locationValue.neighbourhood_id)
                  .name;
              }
              mobileValue = locationValue.mobile;
            }
          } else if (tableMeta.rowData[11] === "warehouse") {
            if (warehousesList.find((e) => e._id == value)) {
              let locationValue = warehousesList.find((e) => e._id == value).location;
              if (citiesList.find((e) => e._id == locationValue.city_id)) {
                cityValue = citiesList.find((e) => e._id == locationValue.city_id).name;
              }
              if (neighbourhoodsList.find((e) => e._id == locationValue.neighbourhood_id)) {
                neighbourhoodValue = neighbourhoodsList.find((e) => e._id == locationValue.neighbourhood_id)
                  .name;
              }
              mobileValue = locationValue.mobile;
            }
          }
          return (
            <div style={{width: 200}}>
              <a onClick={() => handleEditLocation("Edit Location", tableMeta.rowData[0], tableMeta.rowData)}>
                <strong>City</strong>: {cityValue ? cityValue : "-"}
                <br />
                <strong>Neighbourhood</strong>: {neighbourhoodValue ? neighbourhoodValue : "-"}
                <br />
                <strong>Mobile</strong>: {mobileValue ? mobileValue : "-"}
                <br />
              </a>
            </div>
          );
        },
      },
    },
    {
      name: "status",

      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <a onClick={() => handleEditStatus("Edit Status", tableMeta.rowData[0], tableMeta.rowData)}>
                {value}
              </a>
            </div>
          );
        },
      },
    },
    {
      name: "condition",
      label: "Condition",
    },

    {
      name: "is_new",
      label: "Is Received New",
      options: {
        customBodyRender: (value, tableMeta, updateValue) =>
          value != 0 ? <Check className="text-success" /> : <Close className="text-danger" />,
      },
    },
    {
      name: "booked",
      options: {
        customBodyRender: (value, tableMeta, updateValue) =>
          value != 0 ? <Check className="text-success" /> : <Close className="text-danger" />,
      },
    },

    {
      name: "createdBy",
      label: "Created By",
    },
  ];
  const tabsTitle = ["Operational", "Quarantine", "Major Maintenance", "Damaged", "Discontinued"];
  const handleImport = () => {
    setImportModalVisible(true);
  };
  const closeImport = (refresh) => {
    setImportModalVisible(false);
    fetchData();
  };

  const options = {
    filter: false,
    onRowsDelete: null,
    rowsPerPage: pagingInfo.limit,
    rowsPerPageOptions: [10, 50, 100],
    selectToolbarPlacement: "replace",
    download: false,
    customToolbar: () => {
      return (
        <CustomToolbar
          importXlsx={handleImportXlsx}
          listener={() => {
            handleAdd("Add New Cabinet");
          }}
          handleFilter={handleFilter}
          handleExport={handleExport}
          handleImport={handleImport}
        />
      );
    },
    onRowsDelete: (rowsDeleted, dataRows) => {
      const idsToDelete = rowsDeleted.data.map((d) => items[d.dataIndex]._id); // array of all ids to to be deleted
      axios
        .delete(`${process.env.REACT_APP_BASE_URL}/cabinets/${idsToDelete}`, {
          responseType: "json",
          headers: {Authorization: `Bearer ${token}`},
        })
        .then((response) => {
          console.log("deleted");
        });
    },
    // onDownload: (buildHead, buildBody, columns, data) => {
    //   let tableOptions = [
    //     {name: "sn", label: "Serial Number", download: true},
    //     {name: "sn2", label: "Secondary SN", download: true},
    //     {name: "type", label: "Type", download: true},
    //     {name: "client", label: "Client", download: true},
    //     {name: "mobile", label: "Mobile", download: true},
    //     {name: "location_type", label: "Location Type", download: true},
    //     {name: "location_name", label: "Location Name", download: true},
    //     {name: "city", label: "City", download: true},
    //     {name: "neighbourhood", label: "Neighbourhood", download: true},
    //     {name: "brand", label: "Brand", download: true},
    //     {name: "status", label: "Status", download: true},
    //     {name: "prev_status", label: "Previous Status", download: true},
    //     {name: "is_new", label: "Is Received New", download: true},
    //     {name: "booked", label: "Booked", download: true},
    //   ];

    //   // let tableData = cabinetsToExport.data.map((e, i) => ({index: i, data: Object.values(e)}));
    //   // return buildHead(tableOptions) + buildBody(tableData);
    //   /////////////////////////////////////////////////////////////////////////
    //   const fields = tableOptions.map((opt) => opt.name);

    //   const tableData = cabinetsToExport.data.map((item, index) => ({
    //     index,
    //     data: fields.map((field) => item[field] ?? ""), // maintain field order
    //   }));

    //   return buildHead(tableOptions) + buildBody(tableData);
    // },
    // serverSide: true,
    // count: pagingInfo.count, // Use total number of items

    count:
      tabIndex == 0
        ? pagingInfo.count
        : countLive && countLive.data
        ? countLive.data[tabsTitle[tabIndex - 1]] || 0
        : 0,

    page: pagingInfo.page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPagingInfo({...pagingInfo, page: tableState.page, skip: tableState.page * pagingInfo.limit});
      } else if (action === "changeRowsPerPage") {
        setPagingInfo({...pagingInfo, limit: tableState.rowsPerPage});
      }
    },
  };

  const handleExport = async () => {
    try {
      setItemsFiltered();
      let filterArray = [];
      if (filterFormValues.is_new) filterArray.push(`is_new=${filterFormValues.is_new.id}`);
      if (filterFormValues.booking) filterArray.push(`booking=${filterFormValues.booking.id}`);
      if (filterFormValues.condition) filterArray.push(`condition=${filterFormValues.condition.id}`);
      if (filterFormValues.location) filterArray.push(`location=${filterFormValues.location.id}`);
      if (filterFormValues.store) filterArray.push(`location_id=${filterFormValues.store._id}`);
      if (filterFormValues.warehouse) filterArray.push(`location_id=${filterFormValues.warehouse._id}`);

      if (filterFormValues.client._id) filterArray.push(`clientId=${filterFormValues.client._id}`);
      if (filterFormValues.fridgesType._id)
        filterArray.push(`fridgeTypeId=${filterFormValues.fridgesType._id}`);
      if (filterFormValues.prevStatus) filterArray.push(`prevStatus=${filterFormValues.prevStatus}`);
      if (filterFormValues.status) filterArray.push(`status=${filterFormValues.status}`);
      if (filterFormValues.fromDate) filterArray.push(`fromDate=${filterFormValues.fromDate}`);
      if (filterFormValues.toDate) filterArray.push(`toDate=${filterFormValues.toDate}`);

      filterArray.push(`status=${tabIndex > 0 ? tabsTitle[tabIndex - 1] : ""}`);

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/cabinets/export?searchEntry=${searchEntry}&${filterArray.join(
          "&"
        )}`,
        {
          responseType: "blob",
          headers: {Authorization: `Bearer ${token}`},
        }
      );

      // ✅ Create blob and download using anchor
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Cabinets.xlsx"); // filename
      document.body.appendChild(link);
      link.click();

      // ✅ Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  const handleFilter = () => {
    setFilterDialog(true);
  };

  const handleAdd = (title, cabinetId) => {
    setOpenAddForm(true);
    setCabinetId(cabinetId);
    setFormTitle(title);
    setOpenSnDialog(false);
  };
  const handleCloseAddForm = () => setOpenAddForm(false);

  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
  };

  const handleEditStatus = (title, cabinetId, cabinet) => {
    setCabinet(cabinet);
    setOpenEditStatus(true);
    setCabinetId(cabinetId);
    setFormTitle(title);
  };

  const handleCloseEditStatus = () => setOpenEditStatus(false);

  const handleEditLocation = (title, cabinetId, cabinet) => {
    setCabinet(cabinet);
    setOpenEditLocation(true);
    setCabinetId(cabinetId);
    setFormTitle(title);
  };

  const handleCloseEditLocation = () => setOpenEditLocation(false);

  //Search component ---------------START--------------
  const handleChangeSearch = (e, newValue) => {
    console.log(newValue);

    let values = [];

    newValue.forEach((v) => {
      let v_split = v.split(" ");
      v_split.forEach((vv) => {
        if (vv && vv != " ") values.push(vv);
      });
    });
    console.log(values);
    setSearchEntry(values);
  };

  //Search component ---------------END--------------

  return (
    <>
      <TabsOnTop
        items={items}
        setItemsFiltered={setItemsFiltered}
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        countLive={countLive}
      />
      <Container maxWidth="xl" style={{paddingTop: "4rem"}}>
        <Autocomplete
          multiple
          freeSolo
          limitTags={3}
          id="tags-standard"
          options={[]}
          getOptionLabel={(option) => option}
          value={searchEntry}
          onChange={handleChangeSearch}
          renderInput={(params) => (
            <TextField {...params} variant="standard" placeholder="Search Data" label="Filter by SN" />
          )}
        />

        {!isLoading ? (
          <MuiThemeProvider theme={datatableThemeInTabsPage}>
            <MUIDataTable
              title=""
              data={itemsFiltered ? itemsFiltered : items}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        ) : (
          <CircularProgress size={30} className="pageLoader" />
        )}

        <div>
          <Dialog
            maxWidth={"xl"}
            fullWidth
            TransitionComponent={Transition}
            open={openSnDialog}
            onClose={() => setOpenSnDialog(false)}
          >
            <SnDialog
              setOpenDialog={setOpenSnDialog}
              snId={snId}
              cabinetsList={items}
              handleAdd={handleAdd}
            />
          </Dialog>
          {/*below Dialog opens when clicking on edit*/}
          <Dialog fullScreen open={openDialog2} onClose={handleCloseDialog2} TransitionComponent={Transition}>
            <AddFormDialog
              title={modal_Title + " Fridge"}
              handleClose={handleCloseDialog2}
              inputs={[
                {
                  labelText: "Client",
                  type: "select",
                  value: ["option 1", "option 2"],
                },
                {
                  labelText: "Client",
                  type: "select",
                  value: ["option 1", "option 2", "option 3"],
                },
                {labelText: "Sn", type: "text"},
                {labelText: "Sn2", type: "text"},
                {labelText: "Note", type: "text"},
                {labelText: "Branding", type: "text"},
                {labelText: "Preventive/Year", type: "text"},
              ]}
            />
          </Dialog>

          <Dialog fullScreen open={openAddForm} onClose={handleCloseAddForm} TransitionComponent={Transition}>
            <SubTables
              title={formTitle}
              handleClose={handleCloseAddForm}
              cabinetId={cabinetId}
              fridgesTypesList={fridgesTypesList}
              clientsList={clientsList}
            />
          </Dialog>
          {/*********************** FILTER start ****************************/}
          <Dialog
            onClose={() => setFilterDialog(false)}
            maxWidth={"xl"}
            fullWidth
            aria-labelledby="customized-dialog-title"
            open={filterDialog}
          >
            <FilterComponent
              setTabIndex={setTabIndex}
              setCountLive={setCountLive}
              warehousesList={warehousesList}
              storesList={storesList}
              setOpenDialog={setFilterDialog}
              setItems={setItems}
              setPagingInfo={setPagingInfo}
              pagingInfo={pagingInfo}
              searchEntry={searchEntry}
              filterFormValues={filterFormValues}
              setFilterFormValues={setFilterFormValues}
            />
          </Dialog>

          {/*********************** IMPORT EXCEL start ****************************/}
          <Dialog
            onClose={() => setImportXlsx(false)}
            maxWidth={"md"}
            fullWidth
            aria-labelledby="customized-dialog-title"
            open={importXlsx}
          >
            <ImportXlsx setOpenDialog={setImportXlsx} clientsList={clientsList} />
          </Dialog>

          <Dialog
            fullScreen
            open={openEditStatus}
            onClose={handleCloseEditStatus}
            TransitionComponent={Transition}
          >
            <EditStatus
              title={formTitle}
              handleClose={handleCloseEditStatus}
              cabinetId={cabinetId}
              cabinet={cabinet}
              fridgesTypesList={fridgesTypesList}
              clientsList={clientsList}
            />
          </Dialog>

          <Dialog
            fullScreen
            open={openEditLocation}
            onClose={handleCloseEditLocation}
            TransitionComponent={Transition}
          >
            <EditLocation
              warehousesList={warehousesList}
              storesList={storesList}
              title={formTitle}
              handleClose={handleCloseEditLocation}
              cabinetId={cabinetId}
              cabinet={cabinet}
              fridgesTypesList={fridgesTypesList}
              clientsList={clientsList}
            />
          </Dialog>
        </div>
      </Container>

      <UploadExcel visible={importModalVisible} onClose={closeImport} />
    </>
  );
};
export default Cabinet;
